import { render, staticRenderFns } from "./WineBox.vue?vue&type=template&id=13413faf&scoped=true&"
import script from "./WineBox.vue?vue&type=script&lang=ts&"
export * from "./WineBox.vue?vue&type=script&lang=ts&"
import style0 from "./WineBox.vue?vue&type=style&index=0&id=13413faf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13413faf",
  null
  
)

export default component.exports